(function () {
  'use strict';

  var refreshTimer = null;
  var resetTimers = new WeakMap();
  var wineTypes = /^(Red|White|Rosé|Rose|Sparkling|Dessert) Wine$/i;
  var wineTemplates = /^product\.(albarino|blanco|chardonnay|gris|gsm|noir|rose|syrah|tempranillo)$/i;

  function rootUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = root || '/';
    return root.slice(-1) === '/' ? root : root + '/';
  }

  function requestJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'The request could not be completed.');
        }
        return data;
      });
    });
  }

  function getCart() {
    return requestJson(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } });
  }

  function isWineItem(item) {
    var properties = item.properties || {};
    return String(properties._counts_as_wine_bottle) === 'true' || wineTypes.test(item.product_type || '');
  }

  function wineBottleCount(cart) {
    return (cart.items || []).reduce(function (total, item) {
      return total + (isWineItem(item) ? Number(item.quantity || 0) : 0);
    }, 0);
  }

  function formatAud(cents) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function guidance(count) {
    if (count === 0) return 'Choose wines individually; wine orders ship in multiples of three bottles.';
    var remainder = count % 3;
    if (remainder === 0) return count + ' wine bottles selected. Ready for checkout.';
    var needed = 3 - remainder;
    return count + ' wine bottle' + (count === 1 ? '' : 's') + ' selected. Add ' + needed + ' more to complete your shipment.';
  }

  function deliveryProgress(totalPrice) {
    var threshold = 48000;
    if (totalPrice >= threshold) return 'Complimentary delivery applies.';
    return 'Add ' + formatAud(threshold - totalPrice) + ' more for complimentary delivery.';
  }

  function cartRoots() {
    return Array.prototype.slice.call(document.querySelectorAll('.cart-page__summary, .cart-drawer__summary'));
  }

  function removeExtras(root, selector) {
    var nodes = root.querySelectorAll(selector);
    for (var i = 1; i < nodes.length; i += 1) nodes[i].remove();
    return nodes[0] || null;
  }

  function ensureCartMarkup() {
    var created = false;

    cartRoots().forEach(function (root) {
      var totals = root.querySelector('.cart-totals');
      var ctas = root.querySelector('.cart__ctas');
      var message = removeExtras(root, '.wc-cart-guidance');
      var link = removeExtras(root, '.wc-cart-continue');

      if (totals) {
        if (!message) {
          message = document.createElement('div');
          message.className = 'wc-cart-guidance';
          message.setAttribute('role', 'status');
          message.setAttribute('aria-live', 'polite');
          created = true;
        }
        message.setAttribute('data-wc-cart-guidance', '');
        if (message.parentElement !== totals || message !== totals.firstElementChild) {
          totals.insertBefore(message, totals.firstChild);
        }
      } else if (message) {
        message.remove();
      }

      if (ctas) {
        if (!link) {
          link = document.createElement('a');
          link.className = 'wc-cart-continue';
          link.textContent = 'Continue shopping';
          created = true;
        }
        link.setAttribute('data-wc-cart-continue', '');
        link.href = rootUrl() + 'pages/wines';
        if (link.parentElement !== ctas || link !== ctas.lastElementChild) ctas.appendChild(link);
      } else if (link) {
        link.remove();
      }
    });

    return created;
  }

  function updateCartUi(cart) {
    ensureCartMarkup();
    var count = wineBottleCount(cart);
    var valid = count === 0 || count % 3 === 0;

    cartRoots().forEach(function (root) {
      var message = root.querySelector('[data-wc-cart-guidance]');
      if (!message) return;
      message.className = 'wc-cart-guidance ' + (valid ? 'is-valid' : 'is-invalid');
      message.innerHTML = '<strong>' + guidance(count) + '</strong><span class="wc-cart-guidance__shipping">' + deliveryProgress(Number(cart.total_price || 0)) + '</span>';
    });

    document.querySelectorAll('#checkout, .cart__checkout-button').forEach(function (button) {
      if (!valid) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('title', 'Add wine bottles to reach a multiple of three before checkout.');
      } else if (Number(cart.item_count || 0) > 0) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.removeAttribute('title');
      }
    });

    document.querySelectorAll('.additional-checkout-buttons').forEach(function (buttons) {
      buttons.classList.toggle('wc-is-disabled', !valid);
      buttons.setAttribute('aria-hidden', valid ? 'false' : 'true');
    });
  }

  function refreshCartUi() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      getCart().then(updateCartUi).catch(function () {});
    }, 80);
  }

  function dispatchCartUpdate(cart, source) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: source,
        data: {
          source: source,
          itemCount: Number(cart.item_count || 0)
        }
      }
    }));
  }

  function currentTemplate() {
    var main = document.getElementById('MainContent');
    return main ? (main.getAttribute('data-template') || '') : '';
  }

  function isWineProductPage() {
    return wineTemplates.test(currentTemplate()) || !!document.querySelector('[data-wc-counts-as-wine-bottle="true"]');
  }

  function markWineForms() {
    if (!isWineProductPage()) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.querySelector('input[name="properties[_counts_as_wine_bottle]"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_counts_as_wine_bottle]';
      input.value = 'true';
      form.appendChild(input);
    });
  }

  function productHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function chooseVariant(product) {
    var variants = product && product.variants ? product.variants : [];
    if (!variants.length) return null;

    var selectedId = new URL(window.location.href).searchParams.get('variant');
    if (selectedId) {
      for (var i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === String(selectedId)) return variants[i];
      }
    }

    for (var j = 0; j < variants.length; j += 1) {
      if (variants[j].available) return variants[j];
    }
    return variants[0];
  }

  function statusNode(button) {
    var actions = button.closest('.pdp-hero__actions');
    if (!actions) return null;
    var status = actions.querySelector('[data-wc-product-atc-status]');
    if (status) return status;

    status = document.createElement('p');
    status.className = 'wc-product-atc-status';
    status.setAttribute('data-wc-product-atc-status', '');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    actions.appendChild(status);
    return status;
  }

  function setButtonIdle(button) {
    var available = button.getAttribute('data-wc-available') !== 'false';
    button.disabled = !available;
    button.textContent = available ? 'Add to Cart' : 'Sold Out';
    button.classList.remove('added');
    button.removeAttribute('data-wc-adding');
    if (available) button.removeAttribute('aria-disabled');
    else button.setAttribute('aria-disabled', 'true');
  }

  function applyVariant(button, variant) {
    if (!variant) {
      button.removeAttribute('data-variant-id');
      button.setAttribute('data-wc-available', 'false');
      setButtonIdle(button);
      return;
    }
    button.setAttribute('data-variant-id', String(variant.id));
    button.setAttribute('data-wc-available', variant.available ? 'true' : 'false');
    setButtonIdle(button);
  }

  function manageProductButton() {
    if (!isWineProductPage()) return;
    var original = document.getElementById('atc-btn');
    if (!original) return;

    var button = original;
    if (button.getAttribute('data-wc-managed') !== 'true') {
      button = original.cloneNode(true);
      button.setAttribute('data-wc-managed', 'true');
      button.setAttribute('data-wc-available', original.disabled ? 'false' : 'true');
      original.replaceWith(button);
    }

    statusNode(button);
    if (button.getAttribute('data-wc-variant-loaded') === 'true') return;
    var handle = productHandle();
    if (!handle) return;

    button.setAttribute('data-wc-variant-loaded', 'true');
    requestJson(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' }
    }).then(function (product) {
      applyVariant(button, chooseVariant(product));
    }).catch(function () {
      setButtonIdle(button);
    });
  }

  function resetButtonLater(button, delay) {
    var existing = resetTimers.get(button);
    if (existing) clearTimeout(existing);
    resetTimers.set(button, setTimeout(function () { setButtonIdle(button); }, delay));
  }

  function handleProductAdd(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('#atc-btn');
    if (!button || !isWineProductPage()) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (button.disabled || button.getAttribute('data-wc-adding') === 'true') return;
    var variantId = Number(button.getAttribute('data-variant-id'));
    var status = statusNode(button);

    if (!variantId) {
      button.setAttribute('data-wc-available', 'false');
      setButtonIdle(button);
      if (status) status.textContent = 'This wine is not currently available.';
      return;
    }

    button.setAttribute('data-wc-adding', 'true');
    button.disabled = true;
    button.textContent = 'Adding...';
    if (status) status.textContent = '';

    requestJson(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: { _counts_as_wine_bottle: 'true' }
        }]
      })
    }).then(getCart).then(function (cart) {
      button.textContent = 'Added!';
      button.classList.add('added');
      if (status) status.textContent = 'Wine added to your cart.';
      var viewCart = document.getElementById('view-cart-btn');
      if (viewCart) viewCart.classList.add('visible');
      updateCartUi(cart);
      dispatchCartUpdate(cart, 'weathercraft-product-page');
      resetButtonLater(button, 2500);
    }).catch(function () {
      button.textContent = 'Try Again';
      button.disabled = false;
      button.removeAttribute('data-wc-adding');
      if (status) status.textContent = 'We could not add this wine. Please try again.';
      resetButtonLater(button, 2500);
    });
  }

  function fixCatalogueFilters() {
    document.querySelectorAll('.wc-catalogue__filter[data-filter="one-acre-project-wine"]').forEach(function (filter) {
      filter.setAttribute('data-filter', 'one-acre-project');
    });
    document.querySelectorAll('.wc-catalogue__filter[data-filter="amphora-wine"]').forEach(function (filter) {
      filter.setAttribute('data-filter', 'amphora');
    });
  }

  function handleCatalogueUpdate() {
    getCart().then(function (cart) {
      updateCartUi(cart);
      dispatchCartUpdate(cart, 'weathercraft-catalogue');
    }).catch(function () {});
  }

  function addStyles() {
    if (document.getElementById('wc-phase1-finish-styles')) return;
    var style = document.createElement('style');
    style.id = 'wc-phase1-finish-styles';
    style.textContent = '.wc-cart-continue{display:inline-block;margin-top:4px;color:inherit;font-size:.78rem;font-weight:700;text-decoration:underline;text-underline-offset:4px}.wc-cart-guidance{width:100%;margin:0 0 8px;padding:16px;border:1px solid currentColor;font-family:var(--font-body--family);font-size:.78rem;line-height:1.55}.wc-cart-guidance__shipping{display:block;margin-top:5px;font-weight:400;opacity:.72}.wc-cart-guidance.is-invalid{font-weight:600}.additional-checkout-buttons.wc-is-disabled{display:none!important}.wc-product-atc-status{min-height:1.2em;color:rgba(255,255,255,.6);font-size:.75rem;line-height:1.5}';
    document.head.appendChild(style);
  }

  function preventInvalidCheckout(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var checkout = target.closest('#checkout, .cart__checkout-button');
    if (!checkout || checkout.getAttribute('aria-disabled') !== 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function observeCartChanges() {
    var observer = new MutationObserver(function () {
      var missing = cartRoots().some(function (root) {
        return !root.querySelector('[data-wc-cart-guidance]');
      });
      ensureCartMarkup();
      if (missing) refreshCartUi();
    });

    document.querySelectorAll('cart-drawer-component, .cart-page').forEach(function (node) {
      observer.observe(node, { childList: true, subtree: true });
    });
  }

  function initialise() {
    addStyles();
    fixCatalogueFilters();
    markWineForms();
    manageProductButton();
    ensureCartMarkup();
    refreshCartUi();
    observeCartChanges();
  }

  document.addEventListener('click', handleProductAdd, true);
  document.addEventListener('click', preventInvalidCheckout, true);
  document.addEventListener('wc:cart-updated', handleCatalogueUpdate);
  document.addEventListener('cart:update', refreshCartUi);
  document.addEventListener('shopify:section:load', function () {
    fixCatalogueFilters();
    markWineForms();
    manageProductButton();
    ensureCartMarkup();
    refreshCartUi();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
})();
